import * as React from "react";
import EditParameter from "../../Editing/EditParameter";
import Table from "../../../components/Table/Table";
import { Dimmer } from "semantic-ui-react";
import { setParameterExtraProperties, filterUserGroupParameters } from "../../../utils/pdApiUtils";
import { editActions } from "../../../actions/editActions";
import { pdApiActions } from "../../../actions/pdApiActions";
import { liftVersionFilter } from "../../../utils/utils";
import { mainActions } from "../../../actions/mainActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import _ from "lodash";
/**
 * All the following props are passed from parent component
 */
export type LiftParametersTableProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  isLoadingParameters: boolean;
  pdApiActions: typeof pdApiActions;
  editActions: typeof editActions;
  mainActions: typeof mainActions;
  subMenuRoute: State.LiftSubmenu;
  toggleModal: () => void;
  filterOptions: State.FilterOptions;
  columnFilters: Filter[];
  setColumnFilters: (subMenuRoute: State.LiftSubmenu, columnFilter: Filter[]) => void;
};

// Props of the component
type LiftParametersTableState = {
  isModalOpen: boolean;
};

export class LiftParametersTable extends React.Component<
  LiftParametersTableProps,
  LiftParametersTableState
> {
  state = {
    isModalOpen: false
  };

  componentWillUnmount(): void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }

  componentDidMount(): void {
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };

  render(): JSX.Element {
    const {
      columns,
      pdApi,
      mainState,
      isEditActive,
      toggleModal,
      filterOptions,
      isLoadingParameters
    } = this.props;
    const { liftParameters } = pdApi;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    let liftParameterRows: Api.LiftParameter[] = [];
    let filteredRows: Api.LiftParameter[] = [];
    let selectedColumns: State.Column[] = [];

    liftParameterRows = liftParameters.map(
      row => setParameterExtraProperties(row, pdApi) as Api.LiftParameter
    );
    filteredRows = liftVersionFilter(liftParameterRows, filterOptions.selectedKceVersion);

    const filterBinding = (binding: Api.LiftParameterBinding) => {
      const hasProduct =
        filterOptions.selectedKceProduct === -1 ||
        binding.kceProduct.id === filterOptions.selectedKceProduct;
      const hasVersion =
        filterOptions.selectedKceVersion === -1 ||
        binding.kceVersion.id === filterOptions.selectedKceVersion;
      return hasProduct && hasVersion;
    };

    filteredRows = liftParameterRows.filter((parameter: Api.LiftParameter) =>
      filterOptions.selectedKceProduct === -1 && filterOptions.selectedKceVersion === -1
        ? true
        : !!parameter.liftParameterBindings?.find(binding => filterBinding(binding))
    );

    if (filteredRows.length > 0) {
      const filteredUserGroup =
        filterOptions.selectedUserGroup === -1
          ? filteredRows
          : filterUserGroupParameters(filteredRows, filterOptions.selectedUserGroup);

      filteredRows = filteredUserGroup as Api.LiftParameter[];
    }

    selectedColumns = columns["Elevator Parameters"];
    const startingPage = mainState.lastEditedObjectId
      ? (filteredRows.findIndex(parameter => parameter.id === mainState.lastEditedObjectId) / // tslint:disable-line: no-bitwise
          mainState.pageSize) >>
        0
      : 0;
    return (
      <div className="flex-1">
        <div className="flex-1">
          <Table
            startingPage={startingPage}
            rows={filteredRows}
            loading={isLoadingParameters}
            loadingText="Fetching elevator parameters..."
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isParameterSelected}
            pageSize={pageSize}
            handleFilterChange={this.handleFilterChangeDebounced}
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div
              className="edit-view"
              style={{ flex: editSize, width: editSize == 0.3 ? "500px" : "1000px" }}
            >
              <EditParameter toggleModal={toggleModal} groupName="Lift" columns={columns} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }
  /**
   * Returns status if parameter has been selected
   * @param {Api.AnyParameter} fault
   * @returns {boolean}
   */
  private isParameterSelected = (parameter: Api.AnyParameter): boolean => {
    const editedObjectId = this.props.editedObjectId ?? this.props.mainState.lastEditedObjectId;
    if (editedObjectId && parameter.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

export default LiftParametersTable;
